import { api_create_landing_page_lead_path } from '@routes';

import request from './request';

export interface CreateLandingPageLeadParams {
  company_name?: string;
  company_size?: string;
  email: string;
  job_function?: string;
  job_level?: string;
  lead_type: string;
  name?: string;
  newsletter_id?: number | string;
  organization_industry?: string;
  organization_sub_industry?: string;
  postal_code?: string;
  recaptcha_token?: string;
  sub_job_function?: string;
  title_at_company?: string;
}

export interface CreateLandingPageLeadResponse {
  success: boolean;
  redirectUrl?: string;
}

export async function createLandingPageLead(
  params: CreateLandingPageLeadParams
): Promise<CreateLandingPageLeadResponse> {
  const res = await request('post', api_create_landing_page_lead_path(params));
  return res;
}
